import { render, staticRenderFns } from "./BeginVerificationSvg.vue?vue&type=template&id=333eb9f2&"
import script from "./BeginVerificationSvg.vue?vue&type=script&lang=ts&"
export * from "./BeginVerificationSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports